import React from 'react';

function ModelSelector({ 
  selectedModel, 
  availableModels, 
  showModelSelector, 
  onToggleSelector, 
  onChangeModel 
}) {
  return (
    <div className="relative">
      <button
        onClick={onToggleSelector}
        className="px-3 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded flex items-center text-sm gap-2 min-w-[180px]"
      >
        <span className="truncate">
          {availableModels.find(model => model.id === selectedModel)?.name || 'Selectează model'}
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
        </svg>
      </button>
      
      {showModelSelector && (
        <div className="absolute bottom-full mb-1 left-0 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-10 max-h-64 overflow-y-auto w-[300px]">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {availableModels.map((model) => (
              <button
                key={model.id}
                onClick={() => onChangeModel(model.id)}
                className={`block w-full text-left px-4 py-3 text-sm ${
                  selectedModel === model.id 
                    ? 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white' 
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
                role="menuitem"
              >
                <div className="font-medium mb-1">{model.name}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">{model.description}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ModelSelector; 